export function resolveHomePath(url: string): string {
  if (url.startsWith('/investigations')) {
    return '/investigations/dashboard';
  }
  if (url.startsWith('/employee')) {
    return '/employee';
  }
  return '/cases/dashboard';
}
